/**
 * SPODNÁ LIŠTA NA TELEFÓNE (.465).
 *
 * Oto: „Poď na to" – druhý bod z mobilnej sady, po upozorneniach.
 *
 * ── Prečo je to potrebné ─────────────────────────────────────────────────
 * Na telefóne je všetko menu schované pod hamburgerom. Prepnúť sa medzi
 * dvoma sekciami preto znamená tri ťuknutia (hamburger → posunúť zoznam →
 * položka) a menu má cez tridsať položiek. Pri pulte alebo v sklade, kde sa
 * telefón drží v jednej ruke, je to rozdiel medzi „pozriem to hneď" a
 * „pozriem to potom pri počítači".
 *
 * Lišta preto nesie **štyri sekcie, ktoré sa na telefóne otvárajú najviac**
 * (vybral ich Oto): objednávky, schránka, na objednanie a tovar. Zvyšok menu
 * ostáva pod hamburgerom – lišta nie je náhrada menu, je to skratka.
 *
 * ── Čo sa tu stráži ──────────────────────────────────────────────────────
 *  • **Kto na sekciu nemá právo, tú položku nevidí.** Právo sa nekopíruje,
 *    posiela ho App tou istou funkciou, ktorou sa filtruje samotné menu.
 *    Keby sa sem vypísal zoznam rolí, raz by sa rozišiel s tým skutočným.
 *  • **Nezostane prázdna lišta.** Komu neostane ani jedna položka (obchodný
 *    zástupca, marketér, konto baliaceho stola), nedostane ani lištu – prázdny
 *    pruh dole je len ukradnuté miesto.
 *  • **Nezakrýva obsah.** Miesto pod ňou si ustráži `App` odsadením hlavnej
 *    plochy a okno tímového chatu sa nad ňu posunie.
 *  • **Na kiosku nie je.** Baliaci stôl beží na celú obrazovku a jeho vlastné
 *    ovládanie je dole – druhá lišta by mu doň zasahovala.
 */
import { NavLink } from 'react-router-dom';
import { ShoppingCart, Inbox, Truck, Package, Store, Menu } from 'lucide-react';

/* Poradie je poradie na obrazovke, zľava doprava. `flag` a `role` sa
 * vyhodnocujú rovnako ako v menu – preto sú tu tie isté názvy. */
export const SPODNE = [
  { to: '/objednavky', label: 'Objednávky', icon: ShoppingCart, role: ['admin', 'user', 'obchodnik'] },
  { to: '/schranka', label: 'Schránka', icon: Inbox, flag: 'schranka' },
  /* .853 ESHOP – najčastejšia práca Mirky na telefóne */
  { to: '/eshop', label: 'ESHOP', icon: Store, flag: 'eshop', len_mobil: true },
  { to: '/na-objednanie', label: 'Na objednanie', icon: Truck },
  { to: '/tovar', label: 'Tovar', icon: Package, role: ['admin', 'user', 'obchodnik'] },
];

export default function SpodnaLista({ user, smie, onMenu }) {
  const polozky = SPODNE
    .filter((n) => (n.flag ? !!user[n.flag] : n.role ? n.role.includes(user.role) : user.role !== 'obchodnik'))
    .filter((n) => !(user.skryte_sekcie || []).includes(n.to))
    .filter((n) => smie(n.to));

  if (!polozky.length) return null;

  return (
    <nav className="no-print fixed inset-x-0 bottom-0 z-30 flex border-t border-slate-200 bg-white/95 backdrop-blur lg:hidden"
      /* Spodný okraj je kvôli telefónom s gestami namiesto tlačidiel: bez
       * neho by posledný riadok ikon padol pod čiaru na spodku displeja. */
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {polozky.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          className={({ isActive }) => `flex flex-1 flex-col items-center gap-0.5 py-1.5 text-[10px] ${n.len_mobil ? 'md:hidden' : ''} ${
            isActive ? 'text-brand-700' : 'text-slate-500'}`}
        >
          {({ isActive }) => (
            <>
              <n.icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
              <span className="leading-none">{n.label}</span>
            </>
          )}
        </NavLink>
      ))}
      {/* .853 Celé menu na dosah palca – hamburger hore je na veľkom telefóne ďaleko. */}
      {onMenu && (
        <button type="button" onClick={onMenu}
          className="flex flex-1 flex-col items-center gap-0.5 py-1.5 text-[10px] text-slate-500 md:hidden">
          <Menu size={20} strokeWidth={1.8} />
          <span className="leading-none">Menu</span>
        </button>
      )}
    </nav>
  );
}
